import React from 'react';
import styled from 'styled-components';
import { Link } from 'wouter';
import { Page } from './components/Page';
import { PageCard } from './components/PageCard';
import { PageCardLogo } from './components/PageCardLogo';
import { SplashPane } from './components/SplashPane';
import { useIdentify } from './hooks/useIdentify';
import { Colors } from './patterns/Colors';

export const JoinOrganizationPage = () => {
    useIdentify();
    return <Page>
        <PageCard splash={<SplashPane />}>
            <PageCardLogo />

            <Heading>Join an organization</Heading>
            <Body>
                Organizations are invite-only. Ask an owner or admin of the
                organization to send you an invitation link, then open that link
                to join their team.
            </Body>
            <CreateLink href="/organizations/create">or create a new organization</CreateLink>
        </PageCard>
    </Page>;
};

const Heading = styled.h1`
    font-size: 1.25rem;
    font-weight: 500;
    color: ${Colors.text};
    margin: 0 0 0.5rem;
`;

const Body = styled.p`
    font-size: 0.875rem;
    color: ${Colors.text};
    opacity: 0.7;
    margin: 0 0 1rem;
`;

const CreateLink = styled(Link)`
    display: inline-block;
    font-size: 0.875rem;
    color: ${Colors.primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;
